import {
  Flex,
  FlexColumn,
  NumberDisplay,
  Separator,
  TextBody,
  TextLabel,
} from "@opensea/ui-kit"
import { capitalize } from "es-toolkit/compat"
import { useTranslations } from "use-intl"
import type { Currency } from "../../../../providers"

type Props = {
  isLoading?: boolean
  priceUSD: string
  quantity: string
  quantityUsd: string
  currency: Currency
  total: string
}

export function SendReview({
  quantity,
  quantityUsd,
  priceUSD,
  currency,
  total,
}: Props) {
  const t = useTranslations("wallet.SendFlow")
  return (
    <FlexColumn className="gap-6 rounded-lg border border-border-1 bg-bg-additional-1 px-4 py-3 font-mono">
      <TextLabel color="text-secondary" size="xs">
        {t("review.title")}
      </TextLabel>
      <FlexColumn className="gap-4">
        <Flex className="justify-between">
          <TextBody>
            <NumberDisplay value={quantity || 0} />
            &nbsp;{currency.symbol}
            <TextBody color="text-secondary">
              &nbsp;@&nbsp;
              <NumberDisplay display="usd" value={priceUSD} />
            </TextBody>
          </TextBody>
          <TextBody>
            <NumberDisplay display="usd" value={quantityUsd || 0} />
          </TextBody>
        </Flex>
        <Flex className="justify-between">
          <TextBody>{t("review.network")}</TextBody>
          <TextBody>
            <TextBody>{capitalize(currency.chainIdentifier)}</TextBody>
          </TextBody>
        </Flex>
        <Separator orientation="horizontal" />
        <Flex className="justify-between">
          <TextBody weight="semibold">{t("review.total")}</TextBody>
          <TextBody weight="semibold">
            <NumberDisplay display="usd" value={total || 0} />
          </TextBody>
        </Flex>
      </FlexColumn>
    </FlexColumn>
  )
}
